import { render, staticRenderFns } from "./announcement-info.vue?vue&type=template&id=758660e2&scoped=true&"
import script from "./announcement-info.vue?vue&type=script&lang=js&"
export * from "./announcement-info.vue?vue&type=script&lang=js&"
import style0 from "./announcement-info.vue?vue&type=style&index=0&id=758660e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758660e2",
  null
  
)

export default component.exports